import React from 'react';
import { Modal, Typography } from 'antd';
import { QRCodeCanvas } from 'qrcode.react';
import { urlPhotoUpload } from 'services/CONSTANTS';

const { Text } = Typography;

const QRCodeModal = ({ visible, onCancel, idNumber }) => {
    const uploadUrl = `${urlPhotoUpload}?id=${idNumber}`;

    return (
        <Modal
            title="Scan QR Code to Upload Photo"
            open={visible}
            onCancel={onCancel}
            footer={null}
            width={400}
            centered
        >
            <div style={{ 
                textAlign: 'center', 
                padding: '20px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '20px'
            }}>
                <QRCodeCanvas 
                    value={uploadUrl}
                    size={256}
                    level="H"
                    includeMargin={true}
                    style={{ 
                        padding: '12px',
                        backgroundColor: 'white',
                        borderRadius: '8px',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                    }}
                />
                <Text type="secondary" style={{ fontSize: '14px' }}>
                    Scan this QR code with your mobile device to upload a photo for this ID badge.
                </Text>
                <Text type="secondary" style={{ fontSize: '12px' }}>
                    The photo will automatically appear in the form once uploaded.
                </Text>
            </div>
        </Modal>
    );
};

export default QRCodeModal; 